// extracted by mini-css-extract-plugin
export default {"content_footer":"footer_content_footer__-Bzt4","container_infos":"footer_container_infos__UP5W2"};